import { SelectItem } from "primeng/api/selectitem";
import {BaseRua} from "./rua.model";
import {Tier} from "./tier.model";

export class Account {
  accountId = 0;
  accountType = '';
  contractType = '';
  address1 = '';
  address2 = '';
  billingAddress1 = '';
  billingAddress2 = '';
  billingCity = '';
  billingCountry = '';
  billingEmail = '';
  billingFirstName = '';
  billingLastName = '';
  billingPhone = '';
  billingState = '';
  billingZipCode = '';
  city = '';
  companyName = '';
  country = '';
  customerFinancialId = 0;
  email = '';
  firstName = '';
  lastName = '';
  noOfUsers = 0; // place holder - servicedesk's "No. of Users"
  npacUserType = '';
  pendingTier = '';
  phone = '';
  otherServices = '';
  serviceAgreementAccepted = false;
  spid = '';
  state = '';
  status = '';
  tier = '';
  custom: Tier;
  updateDateTime: Date = new Date();
  zipCode = '';
  ruaList: BaseRua[];
  purchaseOrderNumber = '';
  maxActiveApiSessions = '';
  associatedSpids = [];

  /**
   * validator: pattern for names, e.g., first name, last name, etc.
   */
  public static nameValidatorPattern() {
    return /^\S[\S\s]*$/;
  }

  /**
   * validator: pattern for phone, e.g., min 7 alphanumeric.
   */
  public static phoneValidatorPattern() {
    return /^[A-Za-z0-9]{7,}$/;
  }

  /**
   * validator fn: postal/ zip code, covers US, CA.
   */
  public static zipCodeValidatorPattern(country?: string) {
    if (country === 'United States') {
      return /(^\d{5}$)|(^\d{5}-\d{4}$)/;
    }/* else if (country === 'Canada') {
      return /^[A-Za-z]\d[A-Za-z][ -]?\d[A-Za-z]\d$/;
    }*/ else {
      return '';
    }
  }

  /**
   * validator: pattern for digits
   */
  public static numberValidatorPattern() {
    return /[0-9]*$/;
  }

  public static readonly ACCOUNT_TYPE_STANDARD: SelectItem = {label: 'Standard', value: 'standard'};
  public static readonly ACCOUNT_TYPE_NON_STANDARD: SelectItem = {label: 'Non-Standard', value: 'nonStandard'};
  public static readonly ACCOUNT_TYPE_SERVICE_DESK: SelectItem = {label: 'Service Desk', value: 'servicedesk'};
// public static readonly ACCOUNT_TYPE_NULL: AccountType =  { name: '', code: '' };

  public static readonly CONTRACT_TYPE_SIGNED: SelectItem = {label: 'Signed', value: 'signed'};
  public static readonly CONTRACT_TYPE_CLICK_THRU: SelectItem = {label: 'Click Thru', value: 'clickThru'};

  public static readonly ACCOUNT_STATUS_PENDING: SelectItem = {label: 'Pending', value: 'pending'};
  public static readonly ACCOUNT_STATUS_REJECTED: SelectItem = {label: 'Rejected', value: 'rejected'};
  public static readonly ACCOUNT_STATUS_APPROVED: SelectItem = {label: 'Approved', value: 'approved'};
  public static readonly ACCOUNT_STATUS_ACTIVE: SelectItem = {label: 'Active', value: 'active'};
  public static readonly ACCOUNT_STATUS_INACTIVE: SelectItem = {label: 'Inactive', value: 'inactive'};


}
